import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    edit: 'Edit',
    noAddress: 'Address not filled in',
    noSiret: 'SIRET not filled in',
    noVatNumber: 'VAT number not filled in',
    siret: 'SIRET · {0}',
    vatNumber: 'VAT N° · {0}',
  },
  fr: {
    edit: 'Edit',
    noAddress: 'Adresse non renseignée',
    noSiret: 'SIRET non renseigné',
    noVatNumber: 'Numéro de TVA non renseigné',
    siret: 'SIRET · {0}',
    vatNumber: 'N° TVA · {0}',
  },
} as const);

export default locales;
